import React, { useState } from "react";

export function ContactUS() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "IT Consulting Inquiry",
    message: ""
  });

  const [status, setStatus] = useState("idle"); // idle | sending | success | error
  const [responseMsg, setResponseMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setResponseMsg("");

    try {
      // Direct background email delivery to hr@advancedcloudlinktechnologies.com
      const res = await fetch("https://formsubmit.co/ajax/hr@advancedcloudlinktechnologies.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone || "Not provided",
          _subject: `ACT Inquiry: ${formData.subject} - ${formData.name}`,
          topic: formData.subject,
          message: formData.message,
          _template: "table",
          _captcha: "false"
        })
      });

      const data = await res.json();

      if (res.ok && (data.success === "true" || data.success === true || data.message)) {
        setStatus("success");
        setResponseMsg("Thank you! Your message has been sent successfully to hr@advancedcloudlinktechnologies.com. Our team will contact you shortly.");
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "IT Consulting Inquiry",
          message: ""
        });
      } else {
        // Fallback to mailto if API returned an issue
        const mailtoLink = `mailto:hr@advancedcloudlinktechnologies.com?subject=${encodeURIComponent(
          formData.subject + " - from " + formData.name
        )}&body=${encodeURIComponent(
          `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
        )}`;
        window.location.href = mailtoLink;
        setStatus("success");
        setResponseMsg("Your inquiry was prepared in your email client. Please click Send to deliver to our HR team.");
      }
    } catch (err) {
      // Fallback to mailto if offline or network issue
      const mailtoLink = `mailto:hr@advancedcloudlinktechnologies.com?subject=${encodeURIComponent(
        formData.subject + " - from " + formData.name
      )}&body=${encodeURIComponent(
        `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
      )}`;
      window.location.href = mailtoLink;
      setStatus("success");
      setResponseMsg("Your inquiry was prepared in your email client. Please click Send to deliver to our HR team.");
    }
  };

  return (
    <div className="contact-page">
      <div className="page-banner">
        <div className="container">
          <span className="badge">Get in Touch</span>
          <h1>Contact Our Consulting Team</h1>
          <p>
            Have a project in mind, need technical staffing, or want a free consultation? We would love to hear from you.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info-panel">
              <div>
                <span className="section-tag">Direct Channels</span>
                <h2 style={{ fontSize: "1.85rem", marginBottom: "1rem" }}>
                  Let's Discuss Your Next Initiative
                </h2>
                <p style={{ color: "#64748b", marginBottom: "1.5rem" }}>
                  Reach out to us directly or fill out the form, and our technology advisory team will respond promptly.
                </p>
              </div>

              <div className="contact-card">
                <div className="contact-card-icon">📍</div>
                <div>
                  <h4>Headquarters</h4>
                  <p>
                    Advanced Cloudlink Technologies Inc<br />
                    520 Mary Ruth PL<br />
                    Celina, TX 75009, USA
                  </p>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card-icon">✉️</div>
                <div>
                  <h4>Email Us Directly</h4>
                  <p>
                    <a href="mailto:hr@advancedcloudlinktechnologies.com">
                      hr@advancedcloudlinktechnologies.com
                    </a>
                  </p>
                  <p style={{ fontSize: "0.85rem", color: "#94a3b8", marginTop: "4px" }}>
                    Inquiries, RFPs & Talent Solutions
                  </p>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card-icon">📞</div>
                <div>
                  <h4>Phone Inquiries</h4>
                  <p>
                    <a href="tel:2142265062">(214) 226-5062</a>
                  </p>
                  <p style={{ fontSize: "0.85rem", color: "#94a3b8", marginTop: "4px" }}>
                    Monday – Friday, 9:00 AM – 6:00 PM CST
                  </p>
                </div>
              </div>
            </div>

            {/* Interactive Contact Form */}
            <div className="contact-form-panel">
              <h3 style={{ fontSize: "1.4rem", marginBottom: "0.5rem" }}>
                Send Us a Message
              </h3>
              <p style={{ color: "#64748b", fontSize: "0.95rem", marginBottom: "1.5rem" }}>
                Fill out the details below and our team will respond directly to your business email.
              </p>

              {status === "success" && (
                <div className="alert-success">
                  <span>✓</span>
                  <span>{responseMsg}</span>
                </div>
              )}

              {status === "error" && (
                <div className="alert-error">
                  <span>⚠️</span>
                  <span>{responseMsg}</span>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label" htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control"
                    placeholder="e.g. Jane Doe"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="email">Business Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    placeholder="e.g. jane@company.com"
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="form-control"
                    placeholder="e.g. (214) 555-0199"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="subject">Topic of Interest</label>
                  <select
                    id="subject"
                    name="subject"
                    className="form-control"
                    value={formData.subject}
                    onChange={handleChange}
                  >
                    <option value="Cloud Migration & Infrastructure">Cloud Migration & Infrastructure</option>
                    <option value="Custom Web & Mobile Development">Custom Web & Mobile Development</option>
                    <option value="Workflow & Process Automation">Workflow & Process Automation</option>
                    <option value="IT Consulting & Staff Augmentation">IT Consulting & Staff Augmentation</option>
                    <option value="General Inquiry / Partnership">General Inquiry / Partnership</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="message">Project Details / Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    className="form-control"
                    rows="4"
                    placeholder="Tell us about your project requirements, timeline, or objectives..."
                    required
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="form-submit-btn"
                  disabled={status === "sending"}
                >
                  {status === "sending" ? "Sending Message..." : "Submit Inquiry →"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
